import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export const Hero = () => {
  const scrollToStart = () => {
    const element = document.getElementById('aviso');
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex flex-col items-center justify-center px-4 overflow-hidden" data-id="element-268">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-269">
        <div className="absolute inset-0 bg-navy-950/80 z-10" data-id="element-270"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-navy-950 via-transparent to-navy-950 z-10" data-id="element-271"></div>
        <img src="https://cdn.magicpatterns.com/uploads/1QX9DPtNhbYk84rQLjYjTe/NOCHE_10.png" alt="Lantern in the dark" className="w-full h-full object-cover opacity-60" data-id="element-272" />
      </div>

      {/* Content */}
      <div className="relative z-20 max-w-3xl mx-auto text-center space-y-8" data-id="element-273">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-274">
          <h1 className="font-serif italic text-5xl md:text-7xl text-cream-100 leading-tight mb-6 drop-shadow-2xl" data-id="element-275">
            10 Noches Sin Que <br data-id="element-276" />
            <span className="text-amber-500" data-id="element-277">La Noche Te Trague</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5,
        duration: 1
      }} className="space-y-4" data-id="element-278">
          <p className="text-xl md:text-2xl text-cream-200 font-light tracking-wide" data-id="element-279">
            Un ritual corto para que el silencio pese menos
          </p>
          <div className="inline-block px-6 py-2 border border-amber-500/30 rounded-full bg-navy-900/40 backdrop-blur-sm" data-id="element-280">
            <p className="text-amber-500 font-medium tracking-wider text-sm md:text-base" data-id="element-281">
              PROTOCOLO 3R (20–30 MINUTOS × 10 NOCHES)
            </p>
          </div>

          {/* CTA Button */}
          <div className="pt-6" data-id="element-282">
            <button onClick={() => {
            const el = document.getElementById('checkout');
            el?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="px-8 py-4 bg-amber-500 text-navy-950 font-bold text-lg rounded-full shadow-[0_0_30px_rgba(212,165,116,0.3)] hover:bg-amber-400 hover:shadow-[0_0_40px_rgba(212,165,116,0.5)] transition-all duration-300 cursor-pointer" data-id="element-283">
              Obtener el Libro Completo
            </button>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.button onClick={scrollToStart} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 z-20 text-cream-300 hover:text-amber-500 transition-colors flex flex-col items-center gap-2 cursor-pointer" aria-label="Empezar a leer" data-id="element-284">
        <span className="text-xs uppercase tracking-widest" data-id="element-285">Empezar</span>
        <ChevronDown className="w-6 h-6 animate-bounce" data-id="element-286" />
      </motion.button>

      {/* Ambient Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-amber-500/10 rounded-full blur-[100px] pointer-events-none z-10" data-id="element-287"></div>
    </section>;
};